<template>
	<LoginLayout
		form-title="SSO authentication"
	>
		<template #form>
			<Message>
				Sorry, SSO authentication has failed. Please try again later
			</Message>
			<a @click="$router.push({ path: '/login' })">
				Log in.
			</a>
		</template>
	</LoginLayout>
</template>
<script>
import LoginLayout from '../../../../shared/layouts/login-layout.vue'
import Message from '../../../../shared/components/message.vue'
export default {
	components: { Message, LoginLayout }
}
</script>
